<template>
    <BaseDialog 
        max_width="90%"
        :dialog="dialog"
        title="Seleziona i pesi"
        v-on:close_dialog="closeDialog">
        <div v-if="loading" class="d-flex align-center justify-center flex-column">
            <h2>Calcolo pesi</h2>
            <v-progress-circular 
                indeterminate
                size="200"
                width="20"
                color="primary"
                ></v-progress-circular>
        </div>
        <div class="d-flex flex-column" v-else>
            <div class="d-flex flex-column" v-if="weights.length > 0">
                <v-alert class="d-flex" type="warning" :value="true" v-if="hasIncomplete">
                    Attenzione: stai utilizzando delle pesiere incomplete
                </v-alert>
                <v-alert class="d-flex" type="warning" :value="true" v-if="alertStatus">
                    Valore nominale non raggiungibile
                </v-alert>
                <div class="d-flex justify-end py-2">
                    <v-btn color="primary" @click="calculateOptimal()">Trova ottimo</v-btn>
                </div>
                <v-card v-for="(weightSet, index) in weights" :key="index">
                    <v-card-title primary-title>
                        <h2 class="d-flex flex-grow-1 flex-shrink-0">{{weightSet.name}}</h2>
                        <v-btn text class="d-flex flex-grow-0 flex-shrink-1 ml-2" @click="handleSelectAll(weightSet)">Seleziona tutti i pesi</v-btn>
                    </v-card-title>
                    <v-card-text>
                        <div class="d-flex flex-wrap" >
                            <v-checkbox v-for="(item, index) in weightSet.primary_data.data.values" 
                            :key="index" v-model="selected" 
                            :value="{weightSet: weightSet._id, mass: item._id}" 
                            class="ma-3 d-flex align-items-start">
                                <template v-slot:label>
                                    <div><div class="font-weight-bold">{{item._id}}</div>
                                    <div class="caption">
                                    v. conv.: {{item.conv | formatNumber}}{{instrument_uom}}<br/> 
                                    <i>U: {{item.uncertain_ext | formatNumber}}{{getUncertain(instrument_uom)}}</i></div>
                                    </div>
                                </template>
                            </v-checkbox>
                        </div>
                    </v-card-text>
                </v-card>
                <v-flex xs12 text-left pa-2>
                    <span class="headline"><b> Valore nominale:</b>{{nom | formatNumber}}{{instrument_uom}}</span><br/>
                </v-flex>
            </div>
            <div class="d-flex headline" v-else>
                Non hai selezionato alcuna pesiera!
            </div>
        </div>
        <template v-slot:action>
            <div class="d-flex align-center justify-center my-4">
                <v-btn color="primary" :disabled="selected.length == 0" @click="saveDialog">Salva</v-btn> 
                <v-btn text class="ml-2" @click="closeDialog">chiudi</v-btn> 
            </div>
        </template>
    </BaseDialog>
</template>
<script>
import {createWeightsDict, createAlgoInputs, processAlgoOutput, changeUom, modifyWeightSet} from "../../utils/commonUtils"
import BaseDialog from '../dialogs/BaseDialog'
import {convertPrimaryWeights} from "../../utils/commonUtils"
// // import _ from 'lodash'
import Big from "big.js"

export default {
    components: {BaseDialog},
    data() {
        return {
            dialog: false,
            selected: [],
            headers: [
                {text: "Nominale", align: "left", sortable: false},
                {text: "Matricola",  align: "left", sortable: false},
                {text: "Convenzionale", align: "left", sortable: false},
                {text: "Incertezza", align: "left", sortable: false}
            ],
            nom: 0,
            weights:  [],
            pagination: {'rowsPerPage': -1},
            warningOn: false,
            instrument_uom: "g",
            instrument_precision: 0,
            dialogWorker: null,
            loading: false
        }
    },
    computed:{
        calculateSum(){
            if(this.weights && this.selected.length > 0){
                return this.selected.reduce((a,b) => Big(a).plus(b.name).toString(),0)
            }
            return 0
        },
        hasIncomplete(){
            if(this.weights){
                for(let weight of this.weights){
                    if(weight.primary_data.complete == false){
                        return true
                    }
                }
            }
            return false
        },
        alertStatus(){
            if(this.warningOn && !this.hasIncomplete){
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        workerOutput(e){
            this.selected = processAlgoOutput(e.data.result, e.data.dict, e.data.decimals)
            if(this.selected.length === 0){
                this.warningOn = true
            } else {
                this.warningOn = false
            }
            this.loading = false
        },
        calculateDefault(alreadySelected){
            if(this.nom && this.weights){
                if(alreadySelected.length > 0  && this.verify(alreadySelected)){
                    this.selected = _.cloneDeep(alreadySelected)
                } else {
                    this.calculateWithWorker('greedy')
                }
            }
        },
        calculateWithWorker(type){
            this.loading = true
            let newDict = createWeightsDict(this.weights)
            let algoInputs = createAlgoInputs(newDict)
            let nNom = this.nom * Math.pow(10, algoInputs.decimals)
            this.dialogWorker.postMessage({nom: nNom, arrVals: algoInputs.arrVals, dict: newDict, decimals: algoInputs.decimals, origin: type})
        },
        calculateOptimal(){
            this.calculateWithWorker('optimal')
        },
        
        getUncertain(uom){
            if(uom){
                switch(uom){
                    case "g": return "mg"
                    case "kg": return "g"
                }
            }
            return ""
        },
        verify(selected){
            let ids = this.weights.map( function(elem){
                return elem._id
            })
            for (let item of selected){
                if(!ids.includes(item.weightSet)){
                    console.log("non trovato ", item, ids)
                    return false
                }
            }
            let items = convertPrimaryWeights(selected, this.weights, this.instrument_uom, false)
            let sum =  items.reduce((a,b) => Big(a).plus(b.name).toString(),0)
            if (sum != this.nom) {
                return false
            }
            return true
        },
        openDialog(nom,weights, instrument_uom, instrument_precision, alreadySelected = []){
            this.selected = []
            this.nom = nom
            this.instrument_uom = instrument_uom
            this.instrument_precision = instrument_precision
            if(weights){
                this.weights = changeUom(_.cloneDeep(weights), this.instrument_uom)
                modifyWeightSet(this.weights)
            }
            this.dialogWorker = new Worker('./myWorker.js'),
            this.dialogWorker.addEventListener('message', this.workerOutput, false)
            this.calculateDefault(alreadySelected)
            this.dialog = true
        },
        closeDialog(){
            this.dialogWorker.removeEventListener('message', this.workerOutput)
            this.dialogWorker.terminate()   
            this.dialog = false
        },
        saveDialog(){
            this.$emit("weightsConfirmed", this.selected)
            this.closeDialog()
        },
        handleSelectAll(weightSet){
            for(let weight of weightSet.primary_data.data.values){
                if(this.selected.find(function(element){
                    if(weight.instrument == element.weightSet){
                        console.log("uguali")
                        if(weight._id == element.mass ){
                            console.log("non uguali")
                            return true
                        }
                    }
                    return false
                }) != undefined){
                    console.log("CONTINUE")
                    continue 
                } else {

                    this.selected.push({weightSet: weight.instrument, mass:weight._id})
                }
            }
        },
        
        
        
    },
}
</script>